(function () {
    /**
     * Use a flag for initialization to avoid compatibility issues
     * with the WebToffee Cookie Consent plugin.
     */
    let isInitialized = false;

    window.addEventListener("DOMContentLoaded", () => {
        if (!isInitialized) {
            isInitialized = true;
            init();
        }
    });

    const init = () => {
        const els = document.querySelectorAll(".em-block-dynamic-pricing");
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // Check user settings for Prefers reducer motion and compatibility for Intersection Observer
        if (!prefersReducedMotion && 'IntersectionObserver' in window) {
            [...els].forEach(setupDynamicNumber);
        }
    };

    const setupDynamicNumber = (el) => {

        // Define the price element and its start & target values
        const thePriceElem = el.querySelectorAll(".em-block-dynamic-pricing__final-price-number")[0];
        const startPrice   = parseFloat( thePriceElem.dataset.startvalue, 10 );
        const targetPrice  = parseFloat( thePriceElem.dataset.targetvalue, 10 );

        // Animate the price number by counting down to the final price from the combination of the two membership prices
        const animateCountDown = (element) => {
            let theStart = startPrice;
            let theEnd = targetPrice;
            const multiplier = ((theStart - theEnd) * 0.01).toFixed(2);

            // Check that the start price is higher than target price and multiplier is positive
            // If not, don't add countdown animation
            if (theStart > theEnd && multiplier > 0) {
                
                const countDown = setInterval(function() {
                    theStart = (theStart - multiplier).toFixed(2)
                    element.textContent = theStart.replace(".", ",");

                    if ( theStart <= theEnd ) {
                        theEnd = theEnd.toFixed(2)
                        element.textContent = theEnd.replace(".", ",");
                        
                        clearInterval(countDown)
                    }

                }, 20); 
            }
        }
    

        // Start animation on scroll
        let options = {
            rootMargin: "100px 0px 0px 0px",
        };

        const observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(item) {
                if(item.isIntersecting) {
                    observer.unobserve(item.target);
                    animateCountDown(thePriceElem)
                }
            });
        }, options);


        if (el) {
            observer.observe(el);
        }

    };
  
})();
